import * as ValuesApi from "../api/ValuesRequest.js"

export const createValue = (id, data) => async(dispatch) => {
    try {
        const { data: response } = await ValuesApi.createValue(id, data)
        console.log("Inside Value Action Create Value: ")
        console.log(response);
        dispatch({type: "CREATE_VALUE", data: response})
    } catch (error) {
        console.log(error)
    }
}

export const updateValue = (userId, valueId, updatedData) => async (dispatch) => {
    try {
      const { data } = await ValuesApi.updateValue(userId, valueId, updatedData);
      console.log('API Response:', data);
      dispatch({ type: "UPDATE_VALUE", payload: data });
    } catch (error) {
      console.log(error);
    }
  };
  
  export const deleteValue = (userId, valueId) => async (dispatch) => {
    try {
      await ValuesApi.deleteValue(userId, valueId);
      dispatch({ type: "DELETE_VALUE", payload: valueId });
    } catch (error) {
      console.log(error);
    }
  };
